<div class="card-arquivo-anexado">
  <!-- Seção 1: Ícone de paperclip -->
  <div class="card-section icon-section">
    <i class="fa fa-paperclip" title="Arquivo anexado"></i>
  </div>

  <!-- Seção 2: Nome e data do arquivo -->
  <div class="card-section info-section">
    <label class="file-name">{{ arquivo.nomeOriginal }}</label>
    <label class="file-date">Anexado em {{ arquivo.dataOperacao | date:'dd/MM/yyyy' }} às {{ arquivo.dataOperacao | date:'HH:mm' }}</label>
  </div>

  <!-- Seção 3: Ícones de ação -->
  <div class="card-section action-section">
    <i class="fa fa-eye action-icon icon-blue" title="Visualizar Arquivo" (click)="onVisualizarClick()"></i>
    <i class="fa fa-download action-icon icon-blue" title="Baixar Arquivo" (click)="onDownloadClick()"></i>
    <i *ngIf="showRemoveButton" class="fa fa-trash action-icon icon-red" title="Remover arquivo" (click)="onRemoverClick()"></i>
  </div>
</div>
